import { Component, OnInit, Input } from '@angular/core';
import { HelpSupport } from '@model';

@Component({
    selector: 'app-help-support',
    templateUrl: './help-support.component.html',
    standalone: false
})
export class HelpSupportComponent implements OnInit {
  @Input()
  supportData: HelpSupport;

  constructor() {}

  ngOnInit() {}
}
